// Match the $break-small breakpoint used by the homepage hero styles.
function initHomeVideos() {
  const videos = document.querySelectorAll('.js-home-desktop-video');
  if (!videos.length) return;

  const mobileViewport = window.matchMedia('(max-width: 600px)');

  function updateVideos() {
    videos.forEach(function (video) {
      const source = video.querySelector('source[data-src]');
      if (!source) return;

      if (mobileViewport.matches) {
        // Detach the source to stop further media loading after a resize.
        if (source.hasAttribute('src')) {
          video.pause();
          source.removeAttribute('src');
          video.load();
        }
        return;
      }

      // Preserve desktop autoplay, including the existing hover previews.
      if (!source.hasAttribute('src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        video.load();
        const playback = video.play();
        if (playback) playback.catch(function () {});
      }
    });
  }

  updateVideos();
  if (mobileViewport.addEventListener) {
    mobileViewport.addEventListener('change', updateVideos);
  } else {
    mobileViewport.addListener(updateVideos);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomeVideos);
} else {
  initHomeVideos();
}
